<template>
    <c-dialog
            ref="dialog"
            title="关联流程"
            width="500"
            mode="slide"
            @resolve="submitHandle"
    >
        <c-form ref="form" column="1" vertical unit-width="100%">
            <c-input type="hidden" name="id"></c-input>

            <c-form-item label="关联流程" required>
                <c-select name="process_id" async @search="searchProcess" :value-data="selectedProcess"></c-select>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
export default {
    data() {
        return {
            currentData: null,
            selectedProcess: []
        }
    },

    methods: {
        open(data) {
            this.currentData = data;
            if(this.currentData.process_id){
                this.selectedProcess = [
                    {
                        name: this.currentData.process_name,
                        value: this.currentData.process_id
                    }
                ];
            }
            this.$refs.form.clear();
            if (data) {
                this.$refs.form.set(data);
            }
            this.$refs.dialog.open();
        },

        submitHandle(stop, next) {
            stop();
            this.$refs.form.submit({
                url: '/flow/form/model/set',
                rule: {
                    process_id: '请选择流程',
                },
                dataFormatter: (data) => {
                    data.form_id = this.currentData.id;
                    return data;
                },
                success: (data, res) => {
                    next();
                    this.$message({
                        message: '关联成功',
                        type: 'success'
                    });
                    this.$emit('resolve', res);
                },
                error: (error) => {
                    console.error('保存失败:', error);
                    this.$message({
                        message: error.message || '保存失败，请重试',
                        type: 'error'
                    });
                }
            });
        },
        /*******搜索流程*****************/
        searchProcess(keyword, resolve){
            this.request({
                url:'/flow/workflow/select_list',
                data: {
                    processName:keyword
                },
                success:data => {
                    console.log(data)
                    var newData = [];
                    for(var i=0;i<data.length;i++){
                        newData.push({
                            name:data[i].processName,
                            value:data[i].id
                        });
                    }
                    resolve(newData);
                }
            })
        },
    }
}
</script>

<style lang="stylus" scoped>
</style>
